import React, { useState, useEffect, useRef } from 'react';
import classes from './AddTaskModal.module.css';
import IconButton from '@mui/material/IconButton';
import ModalSkeleton from '../ModalSkeleton';
import { Input } from '../../Component/Input/Input';
import { TextArea } from '../../Component/TextArea';
import { Button } from '../../Component/Button/Button';
import { DropDown } from '../../Component/DropDown/DropDown';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import TextField from '@mui/material/TextField';
import { DatePicker } from '@mui/x-date-pickers';
import dayjs from '../../utils/timeUtils';
import { Col, Row } from 'react-bootstrap';
import { enUS } from '@mui/x-date-pickers/locales';
import 'dayjs/locale/en';
import TimePicker from 'react-bootstrap-time-picker';
// import { todoRepeatOptions } from '../../constant/commonData';
// import { Checkbox } from '../../Component/Checkbox/Checkbox';
import { FaStop, FaMicrophone } from 'react-icons/fa';

const AddTaskModal = ({
  show,
  setShow,
  handleSubmit,
  type = 'task',
  data,
  optionsArrayStages = [],
  isLoading = false,
  allAdmins,
  isShowProjectDropdown = false,
  setProjectData,
  projectData,
  allCompanies,
  loadingProjects,
}) => {
  const [taskName, setTaskName] = useState(data?.title || '');
  const [assignTo, setAssignTo] = useState([]);
  const [description, setDescription] = useState(data?.description || '');
  const [status, setStatus] = useState('');
  const [noOfDays, setNoOfDays] = useState(data?.noOfDays || '');
  const [deadlineDate, setDeadlineDate] = useState(
    dayjs(data?.deadlineDate || dayjs()),
  );
  const [isListening, setIsListening] = useState(false);
  const recognition = useRef(null);
  const [error, setError] = useState('');

  const startListening = () => {
    if (recognition.current && !isListening) {
      setError('');
      recognition.current.start();
      setIsListening(true);
    }
  };

  const stopListening = () => {
    if (recognition.current && isListening) {
      recognition.current.stop();
      setIsListening(false);
    }
  };

  useEffect(() => {
    if (!('webkitSpeechRecognition' in window) && !('SpeechRecognition' in window)) {
      setError('Speech recognition not supported in this browser. Please use Chrome.');
      return;
    }

    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    recognition.current = new SpeechRecognition();
    
    recognition.current.continuous = true;
    recognition.current.interimResults = true;
    recognition.current.lang = 'en-US';
    
    // Handle results
    recognition.current.onresult = (event) => {
      let finalTranscript = '';
      let interimTranscript = '';
      
      for (let i = event.resultIndex; i < event.results.length; i++) {
        const result = event.results[i];
        if (result.isFinal) {
          finalTranscript += result[0].transcript + ' ';
        } else {
          interimTranscript += result[0].transcript;
        }
      }
      
      if (finalTranscript) {
        setDescription(prev => prev + finalTranscript);
      }
    };
    
    // Handle errors
    recognition.current.onerror = (event) => {
      setError(`Error: ${event.error}`);
      setIsListening(false);
    };
    
    // Handle end of recognition
    recognition.current.onend = () => {
      setIsListening(false);
    };
    
    return () => {
      if (recognition.current) {
        recognition.current.stop();
      }
    };
  }, []);

  // const [isRepeat, setIsRepeat] = useState(data?.isRepeat || false);
  // const [repeatInterval, setRepeatInterval] = useState(
  //   todoRepeatOptions?.find((e) => e.value == data?.repeatInterval) ||
  //     todoRepeatOptions[0],
  // );
  // const [repeatEndTime, setRepeatEndTime] = useState(
  //   data?.repeatEndTime ? dayjs(data?.repeatEndTime) : dayjs(),
  // );

  const [milliseconds, setMilliseconds] = useState(
    ((deadlineDate) => {
      // debugger;
      const time = deadlineDate ? dayjs(deadlineDate) : dayjs().add(1, 'hour');
      const m = time.get('minute');
      const h = time.get('hour');
      return Math.floor((h * 3600 + m * 60) / 1800) * 1800;
    })(data?.isAdd ? null : dayjs(data?.deadlineDate)),
  );

  useEffect(() => {
    setDeadlineDate(
      deadlineDate
        .set('hour', Math.floor(milliseconds / 3600))
        .set('minute', Math.floor((milliseconds % 3600) / 60)),
    );
  }, [milliseconds]);

  const HandleSubmitData = () => {
    // `assignedTo` arrives populated (user objects) from getSingleProject but
    // as raw id strings from the apply-template / stage responses. Accept
    // either shape: mapping a raw id to `item._id` yields [undefined], and
    // [undefined] == '' is true in JS, so the caller's required-field check
    // would reject a save that only changed the due date.
    const newAssignToArray = Array.isArray(assignTo)
      ? assignTo.map((item) => item?._id ?? item).filter(Boolean)
      : [];
    // Capitalising via `description[0]?.toUpperCase()` yields the *string*
    // "undefined" when the description is empty, and re-saving then turns it
    // into "Undefined". Only capitalise when there is something to capitalise.
    const cleanDescription = description
      ? `${description[0].toUpperCase()}${description.slice(1)}`
      : '';

    if (type == 'task') {
      handleSubmit({
        title: taskName,
        assignedTo: newAssignToArray,
        description: cleanDescription,
        type,
        deadlineDate,
        ...(data?.isAdd && { stageId: status?._id }),
        // isRepeat,
        // repeatInterval: repeatInterval?.value,
        // repeatEndTime: dayjs(repeatEndTime)?.toDate(),
      });
    } else {
      handleSubmit({
        title: taskName,
        assignedTo: newAssignToArray,
        description: cleanDescription,
        type,
        ...(type == 'template' && { noOfDays: Number(noOfDays) }),
      });
    }
  };

  useEffect(() => {
    if (data?.assignedTo) {
      setAssignTo(data?.assignedTo);
    }
  }, [data]);

  const initialStatus = () => {
    const statusData = optionsArrayStages?.find(
      (item) => item?.name === 'To Do',
    );

    if (statusData) {
      setStatus(statusData);
    }
  };

  useEffect(() => {
    if (optionsArrayStages?.length && !status && data?.isAdd) {
      initialStatus();
    }
  }, [status, optionsArrayStages, data?.isAdd]);

  return (
    <>
      <style>{`
      .MuiFormControl-root{
        width: 100%;
      }
      .MuiFormLabel-root {
        color: var(--placeholder-color) !important;
      }
      .MuiOutlinedInput-notchedOutline {
        box-shadow: 0px 0 5px 2px #0000000d;
        border-width: 0;
        border: none;
        border-radius: 10px;
        box-shadow: 0px 0 5px 2px #0000000d;
      }
      `}</style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        borderRadius="20px"
        width="734px"
        borderLine={false}
        header={data?.isAdd ? 'Add Task' : 'Edit Task'}
        showCloseIcon={true}
      >
        <LocalizationProvider
          dateAdapter={AdapterDayjs}
          adapterLocale="en"
          localeText={
            enUS.components.MuiLocalizationProvider.defaultProps.localeText
          }
        >
          <div className={classes.add_task_main}>
            {!isShowProjectDropdown && (
              <div className={classes.input_main}>
                <Input
                  setter={() => {}}
                  value={data?.project}
                  customStyle={{
                    borderRadius: '10px',
                    border: 'none',
                  }}
                  inputStyle={{ borderColor: 'none' }}
                  placeholder={'Project Name'}
                  autoFocus={true}
                />
              </div>
            )}

            {isShowProjectDropdown && !loadingProjects && (
              <div className={classes.input_main}>
                <DropDown
                  disabled={!data?.isAdd}
                  isMulti={false}
                  setter={(data) => {
                    setAssignTo(data?.assignTo);
                    setProjectData(data);

                    const statusData = data?.stages?.find(
                      (item) => item?.name === 'To Do',
                    );

                    if (!status && statusData) {
                      setStatus(statusData);
                    }
                  }}
                  value={projectData}
                  placeholder={'Select Project'}
                  options={allCompanies}
                  getOptionLabel={(e) => `${e?.name}`}
                  getOptionValue={(e) => `${e?._id}`}
                  autoFocus={isShowProjectDropdown ? true : false}
                />
              </div>
            )}

            <div className={classes.input_main}>
              <Input
                setter={setTaskName}
                value={taskName}
                customStyle={{
                  borderRadius: '10px',
                  border: 'none',
                }}
                inputStyle={{ borderColor: 'none' }}
                placeholder={'Task Name'}
              />
            </div>
            {type == 'template' && (
              <div className={classes.input_main}>
                <DropDown
                  isMulti={true}
                  setter={setAssignTo}
                  value={assignTo}
                  options={allAdmins}
                  placeholder={'Select Assigned Users'}
                  getOptionLabel={(e) =>
                    `${e?.firstName} ${e?.lastName} (${e?.role[0]})`
                  }
                  getOptionValue={(e) =>
                    `${e?.firstName} ${e?.lastName} (${e?.role[0]})`
                  }
                />
              </div>
            )}
            {type == 'task' && (
              <>
                {data?.isAdd && (
                  <div className={classes.input_main}>
                    <DropDown
                      setter={setStatus}
                      value={status}
                      placeholder={'Select Task Status'}
                      options={(optionsArrayStages?.length > 0
                        ? optionsArrayStages
                        : projectData?.stages || []
                      ).map((e) => ({
                        ...e,
                        name: e?.name,
                        value: e?.name == 'Pending' ? 'Overdue' : e?.name,
                      }))}
                      optionLabel={'value'}
                      optionValue={'name'}
                    />
                  </div>
                )}
                {/* {adminAndbrokers && adminAndbrokers?.length &&  */}
                <div className={classes.input_main}>
                  <DropDown
                    isMulti={true}
                    setter={setAssignTo}
                    value={assignTo}
                    placeholder={'Select Assigned Users'}
                    options={allAdmins}
                    getOptionLabel={(e) =>
                      `${e?.firstName} ${e?.lastName} (${e?.role?.[0]})`
                    }
                    getOptionValue={(e) =>
                      `${e?.firstName} ${e?.lastName} (${e?.role?.[0]})`
                    }
                  />
                </div>
                {/* } */}
                <div className={classes.input_main}>
                  <Row>
                    <div style={{ color: 'grey', marginBottom: '0.5em' }}>
                      Deadline *
                    </div>
                    <Col md={6}>
                      <DatePicker
                        value={deadlineDate}
                        onChange={(newValue) => {
                          setDeadlineDate(newValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                            InputLabelProps={{ shrink: false }}
                            onKeyDown={(e) => e.preventDefault()}
                            {...params}
                          />
                        )}
                      />
                    </Col>
                    <Col md={6}>
                      <TimePicker
                        className={classes.BSTimePicker}
                        value={milliseconds}
                        onChange={setMilliseconds}
                      />
                    </Col>
                  </Row>
                </div>
              </>
            )}

            <div className={classes.input_main}>
              <TextArea
                setter={setDescription}
                value={description ? description[0].toUpperCase() + description.slice(1) : ''}
                customStyle={{
                  borderRadius: '10px',
                  border: 'none',
                }}
                inputStyle={{ borderColor: 'none' }}
                placeholder={'Note'}
              />
            </div>
            <div>
              <IconButton
                IconButton
                onClick={startListening}
                sx={{ height: 30, width: 30, color: '#1976d2' }}
                disabled={isListening || !!error}
                size="small"
              >
                <FaMicrophone fontSize="medium" />
              </IconButton>
              <IconButton
                IconButton
                sx={{ height: 30, width: 30, color: '#d32f2f' }}
                size="small"
                disabled={!isListening}
                onClick={stopListening}
              >
                <FaStop fontSize="medium" />
              </IconButton>
            </div>
            {type == 'template' && (
              <div className={classes.input_main}>
                <Input
                  setter={setNoOfDays}
                  value={noOfDays}
                  type={'number'}
                  customStyle={{
                    borderRadius: '10px',
                    border: 'none',
                  }}
                  inputStyle={{ borderColor: 'none' }}
                  placeholder={'No Of Days'}
                />
              </div>
            )}

            {/* <Checkbox
              value={isRepeat ? 'Repeat' : ''}
              label="Repeat"
              setValue={(e) => setIsRepeat(e === 'Repeat')}
            />
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <DropDown
                value={repeatInterval}
                options={todoRepeatOptions}
                optionLabel={'label'}
                optionValue={'value'}
                setter={(e) => setRepeatInterval(e)}
              />
              <div>Until</div>
              <DatePicker
                value={repeatEndTime}
                onChange={setRepeatEndTime}
                sx={{ width: '150px' }}
              />
            </div> */}
            <div className={classes.add_task_btn_main}>
              <Button
                onClick={() => HandleSubmitData()}
                className={classes.add_task_btn}
                label={
                  isLoading
                    ? 'Submitting...'
                    : data?.isAdd == null
                      ? 'Add Task'
                      : 'Save'
                }
                disabled={isLoading}
              />
              <Button
                onClick={() => setShow(false)}
                className={classes.add_task_btn}
                label="Close"
                disabled={isLoading}
              />
            </div>
          </div>
        </LocalizationProvider>
      </ModalSkeleton>
    </>
  );
};

export default AddTaskModal;
